'use strict';

import {setColBoxes} from "./layout";
import {updateGoogleMapMarkers} from "./map";
import {findOne} from "./utils";
import SmoothScroll from 'smooth-scroll';

var smoothScroll = new SmoothScroll( 'a[href*="#"]', {
	topOnEmptyHash: false,
	updateURL: false,
	speed: 1500,
	speedAsDuration: true,
	offset: function( anchor, toggle ) {
		return 0;
	},
} );

$( function() {
	$( '.nav-toggle' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		$( this ).find( '.nav-icon' ).toggleClass( 'active' );
		$( '.nav-elements' ).toggleClass( 'active' );
		$( '.nav-toggle' ).toggleClass( 'active' );
	} );

	$( '.scroll-to' ).on( 'click', function( clickEvent ) {
		var target = false;
		if ( $( this ).attr( 'data-target' ) ) {
			target = $( this ).attr( 'data-target' );
		} else if ( $( this ).attr( 'href' ) ) {
			target = $( this ).attr( 'href' );
		}

		if ( target ) {
			clickEvent.preventDefault();

			$( window ).stop().scrollTo( target, R.settings.scrollSpeed, {
				offset: -$( '.page-menu' ).outerHeight( true ) + 2
			} );
		}
	} );


	$( '.filter-group input' ).on( 'change', function() {
		var activeIds = [];
		var select = [];

		$( this ).parent().removeClass( 'active' );

		$( '.filter-group' ).each( function( filterGroupIndex ) {
			select[ filterGroupIndex ] = {};
			select[ filterGroupIndex ].name = $( this ).attr( 'data-name' );
			select[ filterGroupIndex ].values = [];
			$( this ).find( 'input:checked' ).each( function() {
				$( this ).parent().addClass( 'active' );
				select[ filterGroupIndex ].values.push( $( this ).attr( 'id' ) );
			} );
		} );

		for ( var markerIndex = 0; markerIndex < markers.length; markerIndex++ ) {
			var activeMarker = true;

			for ( var filterIndex = 0; filterIndex < select.length; filterIndex++ ) {
				var key = select[ filterIndex ].name;
				var values = select[ filterIndex ].values;

				if ( values.length > 0 ) {
					if ( !findOne( markers[ markerIndex ][ key ], values ) ) {
						activeMarker = false;
					}
				}
			}

			if ( activeMarker ) {
				activeIds.push( markers[ markerIndex ].id );
			}
		}

		$( '.select' ).addClass( 'inactive' );
		for ( var activeIndex = 0; activeIndex < activeIds.length; activeIndex++ ) {
			$( '#' + activeIds[ activeIndex ] ).removeClass( 'inactive' );
		}

		setColBoxes();
		updateGoogleMapMarkers( activeIds );
	} );

	$( '.toggle' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();

		if ( $( this ).attr( 'href' ) == '#reset' ) {
			$( '.filter-group input' ).removeAttr( 'checked' );
			$( '.filter-group input' ).parent().removeClass( 'active' );
			$( '.select' ).removeClass( 'inactive' )
			setColBoxes();
			updateGoogleMapMarkers( 42 );
		} else {
			$( this ).parents( 'body' ).find( '.toggle' ).removeClass( 'active' );

			var toggleGroup = $( this ).attr( 'data-toggle-group' );

			$( '.' + toggleGroup ).removeClass( 'active' );

			$( '.' + toggleGroup ).each( function() {
				var target = $( this ).attr( 'href' );
				$( target ).removeClass( 'active' );
			} );

			$( this ).addClass( 'active' );

			var target = $( this ).attr( 'href' );
			$( target ).addClass( 'active' );
		}
	} );
} );
